//:::::::::::::::::::::::::
import {
  ModelBooking,
  ModelPaperwork,
  ModelVirtualCare,
  useEffect,
} from 'src/_Shared/global'
import HomeLink from './HomeLink'
import css from './home.module.css'
import ImageHero from 'src/_Shared/images/ImageHero'

import PrimaryNav from 'src/_Shared/components/PrimaryNav/PrimaryNav'
import UpcomingVisits from './UpcomingVisits'
import HomeAccount from './HomeAccount'
//:::::::::::::::::::::::::

export default function HomePartial() {
  useEffect(() => {
    ModelVirtualCare.clear()
    localStorage.removeItem('virtualBookingId')
    ModelBooking.clear()
    ModelPaperwork.clear()
  }, [])
  return (
    <>
      <div className={css.home}>
        <PrimaryNav />
        <ImageHero />
        <div className={css.homeWrap}>
          <UpcomingVisits />
          <h1>How can we help you today?</h1>
          <ul>
            {/* === View Records (External) === */}
            <li>
              <HomeLink
                icon='viewRecords'
                title='View Medical Records'
                subtitle='Sign up to access medical results and visit summary'
                href='https://nextcarepatientportal.azurewebsites.net/'
              />
            </li>
            {/* === Discover Services === */}
            <li>
              <HomeLink
                icon='discoverServices'
                title='Discover More Services'
                subtitle='Find out how we can help you'
                href='https://nextcare.com/what-we-treat'
              />
            </li>
            {/* === Account === */}
            <HomeAccount />
          </ul>
        </div>
      </div>
    </>
  )
}
